<template>
  <v-container fluid grid-list-md v-resize="resizeCardTask" style="padding: 0px !important">
    <!-- p-automation-preview-message responsavel pela automação de enviio de mensagem da tarefa -->
    <p-automation-preview-message ref="automationPreviewMessage"></p-automation-preview-message>
    <!-- // p-add-many-father companyente criado para adicionar várias tarefas -->
    <p-add-many-tasks ref="PAddManyTasks" @savePost="savePostProcess"></p-add-many-tasks>
    <!--Dialog para confirmação de exclusão-->
    <p-confirm :text="`Tem certeza que deseja excluir o item de Tarefas`" :dialog="dialogConfirm" @confirm="confirmDialog" @cancel="() => {this.dialogConfirm = false}"></p-confirm>
    <p-confirm :text="'Tem certeza que deseja duplicar essa tarefa'" :dialog="duplicateDialog" @confirm="confirmDuplicate" @cancel="() => {this.duplicateDialog = false}"></p-confirm>
    <!-- Dialog que mostra uma previsualização do documento -->
    <p-document-preview ref="documentPreview"></p-document-preview>
    <!--Index-->
    <!-- // frame usado para mostrar o tutorial da tela de tarefas -->
    <v-dialog full-width v-model="dialogTaskTutorial" width="730px">
      <v-card>
        <v-card-title primary-title>
          <span class="headline">Tutorial de inclusão de tarefas</span>
          <v-btn icon style="right: 0; position: absolute" slot="activator" fab @click="dialogTaskTutorial=false">
            <v-icon color="#444">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <iframe v-if="dialogTaskTutorial" width="700px" height="410px" src="https://www.youtube.com/embed/qD005wn2xgQ" allowfullscreen>
          </iframe>
           <v-flex xs12>
            <a href="https://www.youtube.com/channel/UChnglEU6grDpO2lHvrmyG0Q/playlists" target="_blank">Clicando aqui</a>
            , Acesse os nossos tutoriais e tenha todas as informações para usar o illis.
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>

    
    <!-- // Tela de Gerenciamento/Inclusão -->
    <!-- <v-navigation-drawer mobile-break-point="100" disable-resize-watcher touchless :value="dialog" right floating absolute :width="widthManageTask"> -->
    <!-- // Se for mobile pega a tela inteira com dialog, se for desktop usa a tela lateral -->
    <v-dialog v-if="mobileTaskEditableScreen" :value="dialog" v-model="dialog" fullscreen hide-overlay transition="scroll-x-reverse-transition">
      <p-task-editable @reloadPage="() => {changePage(page, false)}" @deleteExecute="deleteExecuteProcess" @savePost="savePostProcess" @savePut="savePutProcess" @close="close()" ref="taskEditable" />
    </v-dialog>
    <!-- // mobile-break-point = 100 pois o padrão era 1240 e estava atrapalhando quando a tela chegava nesse tamanho -->
    <!-- // foi incluido o v-show no dialog pois quando abria o inlcuir tarefa normal, e depois abria o incluir rapido e apertava enter, estarva abrindo o navigation drwaer por maid que o dialog estivesse false -->
    <v-navigation-drawer v-else v-show="dialog" mobile-break-point=100 :value="dialog" right floating absolute :width="widthManageTask" style="overflow: hidden;">
      <p-task-editable @reloadPage="() => {changePage(page, false)}" @deleteExecute="deleteExecuteProcess" @savePost="savePostProcess" @savePut="savePutProcess" @close="close()" ref="taskEditable"
      @openTaskFullscreen="openTaskFullscreen()" :taskFullscreen="taskFullscreen"/>
    </v-navigation-drawer>

    <v-layout fill-height>
      <p-task-board ref="boards" v-show="!$vuetify.breakpoint.smAndDown || (!loadingBoard && $vuetify.breakpoint.smAndDown)"  :selectedBoard="selectedBoard" :style="$vuetify.breakpoint.smAndDown ? 'position: absolute; top: 55px; left: 0; width: 100%;' : ''" :mini="board_mini" @loadingBoard="val => loadingBoard = val" @onBoardChange="val => {boardChangeProcess(val)}"  @toggleMini="() => {toggleMini()}" @changeOrderBoard="filterStoreInfo" @openFilterTask="openFilterTask"></p-task-board>
      
      <!-- // Loading -->
      <div v-if="loadingBoard" class="gif-loader">
        <img :src="`${basePath}images/loader.gif`" width="80px"/>
      </div>
        
      <v-layout v-else class="consult-tasks ma-0" wrap>
          <!-- cabeçalho -->
            <!-- titulo da tela de tarefas -->
        <v-flex xs12 style="height: 45px;">
          <v-layout wrap class="ma-0">
            <v-flex md4 xs9>
              <span class="headline" style="overflow: hidden !important;text-overflow: ellipsis !important;display: -webkit-box;-webkit-line-clamp: 1;-webkit-box-orient: vertical;">
                {{this.selectedBoard['id_text'] != '' ? this.selectedBoard['id_text'] : '...'}}
                <v-tooltip bottom :disabled="selectedBoard['hasPermission']">
                  <v-btn slot="activator" icon @click="$refs.boards.editItem()" :disabled="!selectedBoard['hasPermission']" style="margin-top: 0px;margin-left: 0px;margin-bottom: 10px;" >
                    <v-icon color="teal">build</v-icon>
                  </v-btn>
                  <span>Você não possui permissão para editar essa área de trabalho</span>
                </v-tooltip>
              </span>
              
            </v-flex>
            <!-- o search não irá aparecer na dashboard -->
            <v-flex md8 xs12>
              <v-flex md6 xs12>
                <v-text-field v-if="individualFilter['properties']['exibitionType'] <= 2" hide-details :style="($vuetify.breakpoint.smAndDown ? 'margin-top: 48px; margin-bottom: 20px;' : 'margin-top: 0;') + 'padding-top: 0;padding-bottom: 0;'" append-icon="search"
                  label="Pesquisar" v-model="search" @keyup.native="keyupSearch">
                </v-text-field>
              </v-flex>
            </v-flex>
          </v-layout>
        </v-flex>
        <!-- // Opções  -->
        <!-- // options_task - usado para pegar o heitgh e saber quand os filtros vao com o mostrar mais -->
        <v-flex xs12 :style="($vuetify.breakpoint.smAndDown) ? (individualFilter['properties']['exibitionType'] == 3 ? 'min-height: 60px;' : 'min-height: 100px;') : 'min-height: 45px;'" id="options_task">
          <v-layout :style="$vuetify.breakpoint.smAndDown ? 'top: 145px;' : 'padding-right: 10px;'" class="buttons-tasks" wrap>
            <!-- botão de expansão -->
            <v-flex shrink v-if="(!$vuetify.breakpoint.smAndDown) && individualFilter['properties']['exibitionType'] < 2">
              <v-btn style="margin-left: 0px; margin-top: 0px; margin-bottom: 0px;" :loading="loadingBtnAddTask" color="#00acc2" dark @click="() => {openAddTask()}">Adicionar Tarefa</v-btn>
            </v-flex>
            <v-flex shrink v-if="!$vuetify.breakpoint.smAndDown">
              <v-select :items="itemsExibitionType" @change="changeExibitionType" v-model="individualFilter['properties']['exibitionType']" label="Tipo" solo style="width: 150px;" class="small-size-illis" :disabled="!selectedBoard['hasPermission']" hide-details>
                <template v-slot:selection="data">
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <v-avatar size="15">
                        <v-icon :color="data.value === individualFilter['properties']['exibitionType'] ? 'blue' : 'grey'">{{data.item['icon']}}</v-icon>
                      </v-avatar>
                      &nbsp;&nbsp;
                      <span>{{ data.item['text'] }}</span>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </template>
                <template v-slot:item="data">
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <v-avatar size="15">
                        <v-icon :color="data.value === individualFilter['properties']['exibitionType'] ? 'blue' : 'grey'">{{data.item['icon']}}</v-icon>
                      </v-avatar>
                      &nbsp;&nbsp;
                      <span>{{ data.item['text'] }}</span>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </template>
              </v-select>
            </v-flex>
            <!-- // selectedBoard armazena todos os dados atualizados do board selecionado -->
            <v-flex grow>
              <p-filter-task ref="filterTask" :style="$vuetify.breakpoint.smAndDown ? 'top: 10px; right: 0; position: absolute' : ''" @changeIndividualFilter="changeIndividualFilter" :showChip="!$vuetify.breakpoint.smAndDown"></p-filter-task>
            </v-flex>
            <v-flex shrink v-if="!$vuetify.breakpoint.smAndDown">
              <!-- // caso não seja kanban(this.individualFilter['properties']['exibitionType'] !== 2) recarrega os registros, caso seja não recarrega -->
              <v-switch
                hide-details
                style="margin-top: 5px; height: 35px;"
                v-model="individualFilter['properties']['showFinalized']"
                :label="$vuetify.breakpoint.smAndDown ? 'Concluídas' : 'Listar Concluídas'"
                @change="switchFinalized()"
              ></v-switch>
            </v-flex>
          </v-layout>
        </v-flex>
        <!-- // Registros de tarefas -->
        <v-flex xs12 class="pt-0" v-if="individualFilter['properties']['exibitionType'] !== null">
          <p-task-list v-if="individualFilter['properties']['exibitionType'] === 0 || (individualFilter['properties']['exibitionType'] === 1 && $vuetify.breakpoint.smAndDown)" :style="`height:${heightCardTask}px`"  ref="list" :dragDisabled="true" :dontShowSubtasks="individualFilter['properties']['showTaskLevel'] != 1" @sequenceExpanded="sequenceExpandedProcess" @changeAllItem="changeAllItemProcess" @createSubItem="createSubItemProcess" @duplicateTask="openDuplicateDialog" @editSubItem="editSubItemProcess" @doneNewTask="doneNewTask" @deleteSubItem="dialogDelete" @clickMoreTask="clickMoreTask" 
          @changeTaskList="val => items = val" @openDocumentPreviewList="openDocumentPreviewList"
          :totalTasks="pagination.total"
          :taskLoader="expandLoading" idTaskMother="" :allTasks="items" :showCircleInfo="false" :pageTo="pagination.to">
          </p-task-list>
          <p-task-expand v-else-if="individualFilter['properties']['exibitionType'] === 1"  :style="`height:${heightCardTask}px !important;`" ref="expand" :dontShowSubtasks="individualFilter['properties']['showTaskLevel'] != 1"
            :select="select" @updateSort="(p) => {updateSort(p)}" @sequenceExpanded="sequenceExpandedProcess"
            @doneNewTask="doneNewTask" @changeAllItem="changeAllItemProcess" @createSubItem="createSubItemProcess" @editSubItem="editSubItemProcess" @deleteSubItem="dialogDelete" @duplicateTask="openDuplicateDialog" @openDocumentPreviewList="openDocumentPreviewList"
            :loading="expandLoading" :selectedConnection="selectedConnection" :headers="headers"
            :items="items">
          </p-task-expand>
          <kanban v-else-if="individualFilter['properties']['exibitionType'] === 2" :style="`height:${heightCardTask}px !important;margin-top: 10px;`" :heightCardTask='heightCardTask' :search="search" ref="kanban" :showFinalized="individualFilter['properties']['showFinalized']" :individualFilterId="individualFilter['id']" @createTask="createTask" @createSubItem="createSubItemProcess" @editSubItem="editSubItemProcess" @deleteSubItem="dialogDelete" @doneNewTask="doneNewTask" @duplicateTask="openDuplicateDialog" @openDocumentPreviewList="openDocumentPreviewList" :dontShowSubtasks="individualFilter['properties']['showTaskLevel'] != 1">
          <!-- @saveSpecificFilter="(props) => $refs.filterTask.saveSpecificProps(props)"  -->
          </kanban>
          <h2 v-else-if="individualFilter['properties']['exibitionType'] === 3 && !checkPermission('dashboard_custom', 'view')" style="padding-top:">
            Você não tem permissão para visualizar as dashboards. Favor escolher outro tipo de visualização!
          </h2>
          <dashboard-custom v-else-if="individualFilter['properties']['exibitionType'] === 3 && !(selectedBoard['team_id'] > 0)" ref="dashboardCustom">
          </dashboard-custom>
          <h2 v-else-if="individualFilter['properties']['exibitionType'] === 3" style="padding-top:">
            A dashboard só é mostrada em áreas de trabalho individuais. Favor escolher outro tipo de visualização!
          </h2>
          <div v-if="individualFilter['properties']['exibitionType'] === 1" style='border-bottom: 1px solid rgba(0,0,0,0.12)!important; border-left: 1px solid rgba(0,0,0,0.12)!important; border-right: 1px solid rgba(0,0,0,0.12)!important;' class="v-datatable v-table theme--light">
            <div class="v-datatable__actions">
                <div class="v-datatable__actions__select">
                  Registros por página
                <v-select :items="[25,50,75,100]" @change="changePage(page)" v-model="select" class="v-select__selection v-select__selection--comma"></v-select>
                <!-- <input aria-label="Registros por página" readonly="readonly" type="text" autocomplete="on" aria-readonly="false"> -->
                </div>
                <div class="v-datatable__actions__range-controls">
                  <div class="v-datatable__actions__pagination">{{`${this.pagination.from} - ${this.pagination.to} de ${this.pagination.total}`}}</div>
                  <button :disabled="page===1" @click="changePage(page - 1)" type="button" :class="(page===1 ? 'v-btn v-btn--disabled v-btn--flat v-btn--icon theme--light' : 'v-btn v-btn--flat v-btn--icon theme--light')" aria-label="Previous page">
                      <div class="v-btn__content"><i aria-hidden="true" class="v-icon material-icons theme--light">chevron_left</i></div>
                  </button>
                  <button :disabled="page===this.pagination.last_page" @click="changePage(page + 1)" type="button" :class="(page===this.pagination.last_page ? 'v-btn v-btn--disabled v-btn--flat v-btn--icon theme--light' : 'v-btn v-btn--flat v-btn--icon theme--light')" aria-label="Next page">
                      <div class="v-btn__content"><i aria-hidden="true" class="v-icon material-icons theme--light">chevron_right</i></div>
                  </button>
                </div>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-layout>
    <v-layout v-if="!dialog && individualFilter['properties']['exibitionType'] !== 3" class="fab-container" align-center>
      <v-speed-dial open-on-hover>
        <v-tooltip left slot="activator">
          <v-btn id="task_add_btn"  slot="activator" color="primary" fab @click="createTask" :disabled="!checkPermission(entity, 'create') || selectedConnection">
            <v-icon>{{this.translate('system.button.add.icon')}}</v-icon>
          </v-btn>
          <span>{{!checkPermission(entity, 'create') ? createTooltipText : this.translate('system.button.add.title')}}</span>
        </v-tooltip>

        <v-tooltip left v-if="system_add_many_task">
          <v-btn id="task_add_many_btn" slot="activator" fab small color="accent" @click="openAddManyTasks()">
            <v-icon>{{this.translate('system.button.add.icon')}}</v-icon>
          </v-btn>
          <span>Adicionar várias tarefas</span>
        </v-tooltip>
      </v-speed-dial>
    </v-layout>
  </v-container>
</template>

<script>
  import socketTaskConsult from '../mixin/socketTaskConsult'
  import tooltip from '../mixin/tooltip'
  import crud from './../mixin/crud'
  import PConfirm from './shared/PConfirm'
  import PTaskExpand from './shared/PTaskExpand'
  import PAddManyTasks from './shared/PAddManyTasks'
  import PTaskEditable from './shared/PTaskEditable'
  import PTaskList from './shared/PTaskList'
  import PTaskBoard from './shared/PTaskBoard'
  import Kanban from './Kanban'
  import PFilterTask from './shared/PFilterTask'
  import DashboardCustom from './dashboardCustom/DashboardCustom'
  import PDocumentPreview from './shared/PDocumentPreview'
  import PAutomationPreviewMessage from './shared/PAutomationPreviewMessage'

  export default {
    /* eslint-disable eqeqeq, key-spacing, comma-spacing */
    mixins: [crud, socketTaskConsult, tooltip],
    components: {PConfirm, PTaskExpand, PTaskBoard, PTaskList, Kanban, PTaskEditable, PFilterTask, PAddManyTasks, DashboardCustom, PDocumentPreview, PAutomationPreviewMessage},
    data: () => ({
      entity: 'tasks',
      // mobileTaskEditableScreen variavel usada pois quando alternava a tela do pc para maior ou menos, a tela de gerenciamento reiniciava.
      mobileTaskEditableScreen: false,
      taskFullscreen: false,
      loadingBoard: false,
      loadingBtnAddTask: false,
      sequenceExpandedIds: '',
      tasksUsers: [],
      dialog: false,
      dialogTaskTutorial: false,
      itemsExibitionType: [],
      expandLoading: false,
      requestInProgress: false,
      heightCardTask: 0,
      widthManageTask: 0,
      board_mini: false,
      basePath: process.env.API,
      lastSort: {sortBy: 'created_at', descending: true},
      pagination: {
        total: 0,
        per_page: 0,
        current_page: 0,
        last_page: 0,
        from: 0,
        to: 0
      },
      page: 1,
      select: 25,
      du_id: '',
      duplicateDialog: false,
      hasFinalizadaBefore: '',
      deletedItem: [],
      selectedConnection: false,
      setKeyup: null,
      fab: null,
      system_add_many_task: false,
      individualFilter: {
        id: '',
        task_board_id: '',
        properties: {task_template_id:'',exibitionType:null,id_text:'',team_id:[],user_id:[],category:[],client:[],status:'',end_period:'',created_by:'',sortBy:'created_at',descending:true,showTaskLevel:1,showFinalized:true}
      },
      // exibitionType começa null pois se começar com tabela faz requisições sem necessidade
      selectedBoard: {
        id: '',
        properties: {task_template_id:'',exibitionType:null,id_text:'',team_id:[],user_id:[],category:[],client:[],status:'',end_period:'',created_by:'',sortBy:'created_at',descending:true,showTaskLevel:1,showFinalized:true, hasPermission: false}
      }
    }),
    created () {
      this.mobileTaskEditableScreen = this.$vuetify.breakpoint.smAndDown
      // this.$store.commit('loader/change_dialog', true)
      this.$socket.emit('joinRoom', {room: `tasks${this.$auth.user().id}`})
    },
    mounted () {
      // feita a busca das informações previamente salvas do usuario na tela de tarefas como barra de pesquisa e outras configurações
      let filters = this.$store.getters[`filter/values`]
      if (filters['tasks_info']) {
        Object.entries(filters['tasks_info']).forEach(item => {
          // item[0] é key e o item[1] é o value
          // this.$set(this[item[0]], item[1])
          // ja insere diversas informações como a sequenceExpandedIds, search etc
          // incluido item[0] !== 'showFinalized' && item[0] !== 'showSubtasks' && item[0] !== 'exibitionType' pois existem valores que ficaram guardados no task_info de usuários antigos que atualmente da muito trabalho para tirar
          if (item[0] !== 'showFinalized' && item[0] !== 'showSubtasks' && item[0] !== 'exibitionType') this[item[0]] = item[1]
        })
      }
      this.mountExibitionType()
      // Caso não tenha buscado o exibitionType, pega o default
      // if (this.individualFilter['properties']['exibitionType'] === null) this.individualFilter['properties']['exibitionType'] = 1
      // Verifica se o usuário ou a empresa do usuário esta cadastrado para inserir varias tarefas
      let system = this.$store.getters[`system/values`]
      let systemManyTask = system.find(val => val['id_text'] == 'addManyTasks')
      systemManyTask = systemManyTask ? systemManyTask['description'] : false
      if (systemManyTask && systemManyTask != {}) this.system_add_many_task = (systemManyTask['users'].includes(this.$auth.user().id) || systemManyTask['companies'].includes(this.$auth.user().company_id))
    },
    methods: {
      keyupSearch () {
        // caso o usuario fique 1 segundo sem digitar e feita uma busca da pagina novamente
        clearTimeout(this.setKeyup)
        this.setKeyup = setTimeout(() => {
          (this.individualFilter['properties']['exibitionType'] === 2 && this.$refs.kanban) ? this.$refs.kanban.reloadAllStatus() : this.changePage(this.page, false)
          this.filterStoreInfo('search', this.search)
        }, 1000)
      },
      openTaskFullscreen () {
        this.taskFullscreen = !this.taskFullscreen
        this.openManageTask()
      },
      openManageTask () {
        // pega o width da pagina para ver qual será o tamanho que ira abrir a tela lateral gerenciamento e inlcusão de tarefas
        let widthWindow = window.innerWidth || document.body.clientWidth
        if (widthWindow <= 800 || this.taskFullscreen) {
          this.widthManageTask = widthWindow * 1.00
        } else if (widthWindow <= 1500) {
          this.widthManageTask = widthWindow * 0.60
        } else {
          this.widthManageTask = widthWindow * 0.50
        }
        this.dialog = true
      },
      mountExibitionType () {
        this.itemsExibitionType = JSON.parse(JSON.stringify(this.translate('value.board_type')))
        // caso o usuário não tenha permissao pra dashboard ou seja uma area de trabalho comparitlhado, não mostra o item de dashboard
        if (!this.checkPermission('dashboard_custom', 'view') || (this.selectedBoard.hasOwnProperty('team_id') && this.selectedBoard['team_id'] > 0)) this.itemsExibitionType.pop()
      },
      boardChangeProcess (val = {}) {
        // usa Object.assign pois o selectedBoard possue valores que não podem sumir como o hasPermission
        Object.assign(this.selectedBoard, val)
        if (val) {
          this.mountExibitionType()
          // caso passe o cleanSearch irá zerar os valores do campo pesquisar
          if (this.selectedBoard.hasOwnProperty('cleanSearch') && this.selectedBoard['cleanSearch']) {
            this.search = ''
            this.filterStoreInfo('search', this.search)
          }
          this.heightCardTask = (window.innerHeight || document.body.clientHeight) - ((this.$vuetify.breakpoint.smAndDown ? 50 : 0) + (this.individualFilter['properties']['exibitionType'] === 1 ? 270 : 200))
        }
        if (this.selectedBoard.hasOwnProperty('changePage') && this.selectedBoard['changePage']) {
          this.changePageOrkanban()
        }
        // libera o loading do board no boardChangeProcess para que o this.selectedBoard já tenha recebido o valor e consiga usar ele valor em outros lugares como no created da dashboard
        this.loadingBoard = false
      },
      // quando é alterado o individualFIlter para atualizar os valores como exibitionType e listar Concluida
      // tbm é acionado quando abre a pagina
      changeIndividualFilter (individualFilter) {
        Object.assign(this.individualFilter, individualFilter)
        this.changePageOrkanban()
      },
      switchFinalized () {
        if (this.individualFilter['properties']['showFinalized']) {
          // verifica se o usuário possui algum status finalizado nos filtros
          this.$http.get('api/has_status_finalized').then(res => {
            // caso tenha status finalizado no filtro, faz a troca normal
            if (res.body['has_finalized_status'] == true) {
              this.$refs.filterTask.saveSpecificProps({showFinalized: this.individualFilter['properties']['showFinalized']})
              // caso não tenha, mostra um modal para o usuário solicitando que ele inclua pelo menos 1 status de finalização
            } else {
              this.individualFilter['properties']['showFinalized'] = false
              this.$store.commit('snackbar/change_values', {
                text: `Não existe status de conclusão na área de trabalho. Favor editar a área de trabalho e inserir um status de conclusão.`,
                color: 'warning',
                dialog: true
              })
              // this.dialogNotStatusFinalized = true
            }
          }, err => {
            this.individualFilter['properties']['showFinalized'] = !this.individualFilter['properties']['showFinalized']
            console.log(err)
            this.$store.commit('snackbar/change_values', {
              text: `Ocorreu um erro ao listar as concluidas. Favor reportar o erro.`,
              color: 'error',
              dialog: true
            })
          })
        } else {
          this.$refs.filterTask.saveSpecificProps({showFinalized: this.individualFilter['properties']['showFinalized']})
        }
      },
      // atualiza o ExibitionType
      changeExibitionType (val) {
        // Atualiza o exibition type no filtros individual
        this.$refs.filterTask.saveSpecificProps({exibitionType: val})
      },
      sequenceExpandedProcess (sequence) {
        this.sequenceExpandedIds = sequence
        this.filterStoreInfo('sequenceExpandedIds', this.sequenceExpandedIds)
      },
      changePageOrkanban () {
        // caso o exibitionType seja 3 significa que está na dashboard, logo deve buscar os dados novamente
        if (this.individualFilter['properties']['exibitionType'] === 3) {
          // Como a dashboard é criada novamente, já passa pelo reloadDashboard no created do DashboardCustom.vue
          // if (this.$refs.dashboardCustom) this.$refs.dashboardCustom.reloadDashboard()
        } else if (this.individualFilter['properties']['exibitionType'] === 2) {
          // Coloca um setInterval para dar tempo do kanban carregar
          var intervalKanban = setInterval(() => {
            if (this.$refs.kanban) {
              clearInterval(intervalKanban)
              this.$refs.kanban.reloadAllStatus()
            }
          }, 100)
        } else if (this.individualFilter['properties']['exibitionType'] === 1 || this.individualFilter['properties']['exibitionType'] === 0) this.changePage(this.page, false)
      },
      toggleMini () {
        this.board_mini = !this.board_mini
        this.filterStoreInfo('board_mini', this.board_mini)
      },
      filterStoreInfo (key, value) {
        // puxa os filtros por vuex
        let filter = this.$store.getters[`filter/values`]
        // caso o campo não exista ele é inicializado com vazio
        if (!filter[this.entity + '_info']) filter[this.entity + '_info'] = {}
        // Inclui a sequencia caso tenha
        Object.assign(filter['tasks_info'], {sequenceExpandedIds: this.sequenceExpandedIds})
        // o campo no seu key recebe o value
        filter[this.entity + '_info'][key] = value
        // filtros salvos tanto por vuex omo por requisição no back para atualizar no campo de company_user
        this.$store.commit('filter/change_values', filter)
        this.$http.post('auth/change-filter', {'filter': JSON.stringify(filter['tasks_info']), 'entity': 'tasks_info'})
      },
      // verifica se o elemento vindo por socket se encontra nos elementos dos filtros para só assim ser feita uma busca por a pagina novamente
      reloadAllStatusPage () {
        if (this.individualFilter['properties']['exibitionType'] === 2 && this.$refs.kanban) this.$refs.kanban.reloadAllStatus()
      },
      // beforeEditSubTask era pra atualizar a pagina quando encontrasse a mãe, porem por enquanto não tem necessidade de sempre atualizar, pois quando muda o status da filha já está atualizando, e por enquanto é o suficiente
      beforeEditSubTask (value) {
        // let hasItem = this.items.some(val => {
        //   return val.top_id === value.top_id
        // })
        // quem recebe o socket, quando foi alterado uma sub, caso encontre a tarefa do topo, verifica se já está sendo carregado a busca das tarefas, se não tiver faz o carregamento
        // if (hasItem && !this.requestInProgress) this.changePage(this.page, false)
      },
      changePage (page = 1, icon = true, loading = true) {
        // recebe a variavel da sequencia de ids a serem expandidos
        // transformando a variavel seq para string para usar o split
        let seq = JSON.parse(JSON.stringify(this.sequenceExpandedIds)) + ''
        this.page = page
        if (icon) this.$store.commit('loader/change_dialog', true)
        this.requestInProgress = true
        if (loading) this.expandLoading = true
        // verifica o primeiro elemento a expandir
        let firstExpanded = seq.split('.')[0]
        // ele só necessita de simular os clicks se o primeiro elemento da lista de expandiveis n existe na lista
        let hasToClick = !this.items.some(item => { return item.id === parseInt(firstExpanded) })
        let params = {
          taskBoardId: this.individualFilter['task_board_id'],
          page: this.page,
          sequenceExpanded: this.sequenceExpandedIds,
          search: this.search,
          perPage: this.select
        }
        this.$http.post(`api/get_filtered_tasks?`, params).then(res => {
          this.items = res.body.data
          this.pagination = {
            total: res.body.total,
            per_page: res.body.per_page,
            current_page: res.body.current_page,
            last_page: res.body.last_page,
            from: res.body.from,
            to: res.body.to
          }
          if (!!this.$refs.expand && !!this.$refs.expand.pagination) this.$refs.expand.pagination.rowsPerPage = this.select
          this.allItems = JSON.parse(JSON.stringify(res.body.data))
          if (icon) this.$store.commit('loader/change_dialog', false)
          // allStartedTasks serve para voltar tudo quando o allItem já está sendo usado pelas connection.
          this.allStartedTasks = JSON.parse(JSON.stringify(res.body))
          if (seq && typeof seq.split !== 'undefined') {
            // só simula o click na opção de tabela já que foram feitas alterações que fazem a lsta já vir expandida
            // tambem verifica o hasToClick que é a variavel para verificar se necessita simular os varios clicks pois se o objeto
            // não existe na lista anterior ele vem retraido
            if (hasToClick && this.individualFilter['properties']['exibitionType'] === 1) this.seqRecursive(seq.split('.'), 0)
          }
          if (loading) this.expandLoading = false
          this.requestInProgress = false
          this.expandLoading = false
        }, err => {
          console.log(err)
          this.$store.commit('loader/change_dialog', false)
          this.loading = false
          this.$store.commit('snackbar/change_values', {
            text: 'Não foi possível carregar os dados. Reporte o erro.',
            color: 'error',
            dialog: true
          })
          this.requestInProgress = false
          this.expandLoading = false
        })
      },
      // função recursiva para simular um click no botão quando reabrirem as subtarefas, no mmomento que a pagina der reload elas virem abertas
      seqRecursive (seq, i) {
        if (i === seq.length) {
          return
        }
        let first = seq[0]
        setTimeout(() => {
          let button = document.getElementById('subExpand' + seq[i])
          if (button !== null) {
            if (seq[i] !== first) {
              button.click()
            }
          }
          this.seqRecursive(seq, i + 1)
        }, 300)
      },
      openFilterTask () {
        this.$refs.filterTask.openTaskFilter(this.selectedBoard)
      },
      openAddManyTasks () {
        if (this.selectedBoard['company_id'] !== this.$auth.user().company_id) {
          this.$store.commit('snackbar/change_values', {
            text: 'Não é possível adicionar tarefas em empresas parceiras!',
            color: 'warning',
            dialog: true
          })
          return
        }
        this.$refs.PAddManyTasks.openAddManyTasks()
      },
      openAddTask () {
        this.loadingBtnAddTask = true
        this.$store.dispatch('selectedBoard/propertiesAddTask').then((response) => {
          this.loadingBtnAddTask = false
          if (response['openTask']) {
            this.createTask()
          } else {
            let type = this.individualFilter['properties']['exibitionType'] === 0 || this.$vuetify.breakpoint.smAndDown ? 'list' : 'expand'
            if (type === 'expand') {
              setTimeout(() => { // focus setado de acordo com o exibition type para q não ocorra conflitos
                // passado como parametro o defaultItem padrão de uma tarefa de nivel 1
                this.$refs[type].openAddTask(null)
              }, 200)
            } else {
              setTimeout(() => { // focus setado de acordo com o exibition type para q não ocorra conflitos
                // passado como parametro o defaultItem padrão de uma tarefa de nivel 1
                this.$refs[type].openAddTask({identifier: '', user_id: this.$auth.user().id, user_index: '', connection_id: null, connection_company_id: null, team_id: '', category_id: '', client_id: '', task_status_id: '', id_text: '', begin: '', end: '', urgency: '', note: '', recurrence: {type: '', id_text: {each: '', days: '', months: '', daysToCreate: 1}}, password: '', shared: false, sons: [], identifier_sequence: '', level: 1})
              }, 200)
            }
          }
        }, err => {
          console.log(err)
          this.$store.commit('snackbar/change_values', {
            text: `Ocorreu um erro ao carregar os registros, reporte o erro!`,
            color: 'error',
            dialog: true
          })
          this.$store.commit('loader/change_dialog', false)
        })
      },
      // Verifica se existe mais de uma propriedade com mais de um valor
      checkPropertiesAddTask (val) {
        return new Promise((resolve, reject) => {
          this.$http.post('api/check_properties_add_task', this.selectedBoard['properties']).then((res) => {
            resolve(res.body)
          }, (err) => {
            this.$store.commit('snackbar/change_values', {
              text: 'Não foi possível buscar os valores!',
              color: 'error',
              dialog: true
            })
            reject(err)
          })
        })
      },
      doneNewTask (val) {
        this.$refs.taskEditable.doneNewTask(val)
      },
      confirmDialog () {
        this.deleteItem()
      },
      changeAllItemProcess (item, reloadFilter = false) {
        Object.assign(this.allItems.find((val) => { return val.id === item.top_id }), this.items.find((val) => { return val.id === item.top_id }))
      },
      createTask () {
        if (this.selectedBoard['company_id'] !== this.$auth.user().company_id) {
          this.$store.commit('snackbar/change_values', {
            text: 'Não é possível adicionar tarefas em empresas parceiras!',
            color: 'warning',
            dialog: true
          })
          return
        }
        this.openManageTask()
        this.$refs.taskEditable.createTask()
      },
      // change serve para realmente fazer a alteração na lista de tarefas
      changeSubtasksCount (item, type = 'add', change = false, task = null, i = 1) {
        // Quando é a primeira vez verifica se existe filhas pois se tiver muda a sequencia com o changeOrderSequence para ficar mais facil a manipulação
        if (i === 1) {
          task = this.items.find((val) => { return val.id === item.top_id })
          if (item.tree_task_sequence) {
            item.sequence = this.changeOrderSequence(item.tree_task_sequence)
          }
        }
        if (item.task_id === task.id) {
          // se o tipo for de adição irá incluir um registro se não irá tirar
          task.subtasks_clean_count += ((type === 'add') ? 1 : -1)
          if (change) {
            if (type === 'add') {
              task.all_subtasks.push(item)
            } else if (type === 'del') {
              const taskIndex = task.all_subtasks.findIndex((val) => { return val.id === (item.sequence[i] ? item.sequence[i] : item.id) })
              task.all_subtasks.splice(taskIndex, 1)
              // verifica se a tarefa apagada tinha status de finalizada
              if (item['status'] && item['status']['identifier'] === 3) {
                // caso tenha status de finalizada então deve subtrair 1 nas tarefa finalizadas da mãe
                task['finalized_subtasks']--
              }
            }
          }
          return true
        } else {
          let sonItem = task.all_subtasks.find((val) => {
            return val.id === (item.sequence[i] ? item.sequence[i] : item.id)
          })
          if (sonItem) {
            i += 1
            this.changeSubtasksCount(item, type, change, sonItem, i)
          }
        }
      },
      // Mudar a ordem que vem a tree_task_sequence pois ela vai pegando as tarefas maes e encontrando as maes
      changeOrderSequence (values) {
        if (!values) {
          return []
        } else if (values['tree_task_sequence'] === null) {
          return [values.id]
        } else {
          let order = this.changeOrderSequence(values.tree_task_sequence)
          order.push(values.id)
          return order
        }
      },
      // implementação da checagem se a caixa de dialogo vai aparecer ou se a pagina irá recarregar
      beforeSocketSnackbar (item) {
        if (this.editedItem.team_id === item.team_id) {
          this.$store.commit('dialogWarning/change_values', {text: `você foi excluido da equipe ${this.editedItem.team.id_text}, por favor recarregue a pagina!`, showDialog: true})
          return false
        }
      },
      changeIdentifierChildren (allSubtasks, task) {
        let beforeIdentifier = this.$refs.taskEditable.beforeEditedItem.identifier
        if (task.identifier < beforeIdentifier) {
          let subTasks = allSubtasks.filter((val) => { return ((val.identifier >= task.identifier) && (val.identifier < beforeIdentifier) && (val.id !== task.id)) })
          subTasks.map(function (value) {
            let subTask = allSubtasks.find((val) => { return value.id === val.id })
            subTask.identifier++
          })
        // Ou se o novo identifier é maior que o antigo, para decrementar as subtarefas no meio delas.
        } else if (task.identifier > beforeIdentifier) {
          let subTasks = allSubtasks.filter((val) => { return ((val.identifier <= task.identifier) && (val.identifier > beforeIdentifier) && (val.id !== task.id)) })
          subTasks.map(function (value) {
            let subTask = allSubtasks.find((val) => { return value.id === val.id })
            subTask.identifier--
          })
        }
      },
      dialogDelete (item) {
        this.dialogConfirm = true
        this.deletedItem = item
      },
      deleteItem () {
        this.$refs.taskEditable.deleteItem(this.deletedItem)
        this.closeDialogDelete()
        // // Modificando valores para voltar para a tela de consulta
        // this.view = 1
        this.dialog = false
      },
      createSubItemProcess (item) {
        this.$refs.taskEditable.createSubItemProcess(item)
        this.openManageTask()
      },
      openDuplicateDialog (id) {
        this.du_id = id
        this.duplicateDialog = true
      },
      confirmDuplicate () {
        this.duplicateTaskProcess(this.du_id)
        this.duplicateDialog = false
      },
      duplicateTaskProcess (id) {
        this.$store.commit('loader/change_dialog', true)
        this.$http.post('api/duplicate_task', id).then(
          (res) => {
            this.$store.commit('loader/change_dialog', false)
            if (res.body.recurrence === null) {
              res.body.recurrence = {type: '', id_text: {each: '', days: '', months: ''}}
            }
            this.savePostProcess(res.body, 1)
            // abre a tarefa
            this.openManageTask()
            this.$refs.taskEditable.selectTask(res.body['id'], false, true, res.body)
            // Inicia ou para o tempo conforme a edição do status
            this.$refs.taskEditable.companyParamsTime(res.body)
            this.$refs.taskEditable.editedItemDB = JSON.parse(JSON.stringify(res.body))
            // Metodo para adicionar tarefas por socket em todos os lugares necessários
            this.$refs.taskEditable.methodAddTaskSocket(res.body)

            this.$store.commit('snackbar/change_values', {
              text: 'Registro de ' + this.translate('table.' + this.entity + '.title')[0] + ' incluído com sucesso!',
              color: 'success',
              dialog: true
            })
          }, () => { this.$store.commit('loader/change_dialog', false) }
        )
      },
      editSubItemProcess (item, view) {
        if (!this.checkPermission(this.entity, 'manage')) {
          this.$store.commit('snackbar/change_values', {
            text: 'Você não possui acesso para gerenciar tarefas!',
            color: 'warning',
            dialog: true
          })
          return
        }
        this.openManageTask()
        this.$refs.taskEditable.selectTask(item.id, false, true, item)
      },
      deleteExecuteProcess (val) {
        // Verifica se tem o from_tasks pois se tiver significa que é um item da aba de subtarefas do gerenciamento de tarefas caso seja não deve fechar a tela de gerencimento
        if (!(val.hasOwnProperty('from_task') && val['from_task'])) {
          // Dialog para fechar a tela de gerenciamento e ir para de consulta
          this.dialog = false
        }
        let level = val.level
        // Caso as subtarefas estajam mostrando, ao deletar alguma tarefa recarrega tudo, para recarregar todas as tarefas e não apareça subtarefas quando deleta uma tarefa mae
        if (this.individualFilter['properties']['showTaskLevel'] == 0 || (level === 1 || this.individualFilter['properties']['showTaskLevel'] == 1) || (level > 1 || this.individualFilter['properties']['showTaskLevel'] == 2)) {
          if (this.$refs.kanban) {
            this.$refs.kanban.deleteItem(val)
          }
          var index = this.items.findIndex((value) => { return value.id === val.id })
          this.items.splice(index, 1)
          this.pagination.to--
          this.pagination.total--
        } else {
          // a deleção esta sendo feita dentro do changeSubtasksCount
          this.changeSubtasksCount(val, 'del', true)
          for (var prop in val.delTaskUsers) {
            if (val.delTaskUsers[prop] === this.$auth.user().id) {
              var allItemsIndex = this.allItems.findIndex((el) => { return el.id === val.top_id })
              var itemsIndex = this.items.findIndex((el) => { return el.id === val.top_id })
              if (allItemsIndex !== -1) //eslint-disable-line
                this.allItems.splice(allItemsIndex, 1)
              if (itemsIndex !== -1) //eslint-disable-line
                this.items.splice(itemsIndex, 1)
            }
          }
        }
      },
      redoFilter (values, postFilter = true) {
        // Usado para executar o filtro padrão do usuário. Assim é carregado todos os valores para o filtro funcionar
        // É usado um get para buscar o user pois this.$auth.user() não busca o filtro do usuário atualizado
        let filterInterval = setInterval(() => {
          // setInterval para verificar quando termina de carregar o filtro do usuário
          if (this.$store.getters[`filter/loaded`]) {
            if (this.$refs.filter) {
              let userFilter = this.$store.getters[`filter/values`]
              this.$refs.filter.userFilter = userFilter || {}
              this.$refs.filter.filter = {}
              // verifica se existe o filtro
              if ((userFilter || {})[this.entity]) {
                this.$refs.filter.filter = userFilter[this.entity] || {}
              }
              if (Object.keys(this.$refs.filter.filter).length > 0) {
                this.$refs.filter.customFilter(values, postFilter, postFilter)
              }
            }
            // Desabilita o loading
            clearInterval(filterInterval)
          }
        }, 100)
      },
      savePostProcess (val, viewAfterSave = '') {
        let resBody
        // Foi usado o if length para verificar se possui uma tarefa retornada ou nenhuma, para que seja extraido o array ou diretamente.
        if (val.length) {
          resBody = val[0]
          if (resBody.level === 1) {
            this.pagination.total = this.pagination.total + val.length
            this.pagination.to = this.pagination.to + val.length

            // se for kanban percorre cada item e vai adicionando 1 por 1
            if (this.individualFilter['properties']['exibitionType'] === 2) {
              val.forEach((task) => {
                this.$refs.kanban.insertIntoList(task)
              })
            } else {
              this.items = val.concat(this.items)
            }
          } else {
            // changeSubtasksCount já atualiza o allItems
            this.changeSubtasksCount(resBody, 'add', true)
          }
        } else {
          resBody = val
          // Verifica se o level do filtro é todos ou se o level do filtro é de acordo com o level da tarefa, se sim adiciona o item
          if (this.individualFilter['properties']['showTaskLevel'] == 0 || (val.level === 1 && this.individualFilter['properties']['showTaskLevel'] == 1) || (val.level > 1 && this.individualFilter['properties']['showTaskLevel'] == 2)) {
            this.pagination.total++
            this.pagination.to++
            // Se for kanban adiciona o item no kanban
            if (this.individualFilter['properties']['exibitionType'] === 2) {
              this.$refs.kanban.insertIntoList(resBody)
            } else {
              this.items.unshift(val)
            }
          } else {
            // changeSubtasksCount já atualiza o allItems
            this.changeSubtasksCount(val, 'add', true)
          }
        }
        // A verificação da próxima tela a ser aberta(viewAfterSave) é feita dentro do post, pois o Items precisa ter incluido pelo o push os valores
        // para que a próxima tela a ser aberta funcione corretamente
        if (viewAfterSave === 2) {
          this.$store.commit('loader/change_dialog', true)
          if (resBody.level === 1) {
            this.$refs.taskEditable.createTask()
          } else {
            this.createSubItemProcess(null)
          }
        } else if (viewAfterSave === 4) {
          this.$refs.taskEditable.editItem(resBody, viewAfterSave)
        //  viewAfterSave === 4.5 é usado quando está na tela de gerenciamento e não pode nem sair(close) e nem ir na função editItem(). No caso de quando adicionar subtarefa pelo gerenciamento de tarefas
        } else if (viewAfterSave === 4.5) {
          console.log('subtask')
        } else {
          this.close()
        }
      },
      savePutProcess (resBody) {
        let topTask = ''
        // Retira o all_subtasks pois ele retorna vazio e assim não subtituir o já existente por vazio
        delete resBody.all_subtasks
        // Verifica se o level do filtro é todos ou se o level do filtro é de acordo com o level da tarefa, se sim adiciona o item
        if (this.individualFilter['properties']['showTaskLevel'] == 0 || (resBody.level === 1 && this.individualFilter['properties']['showTaskLevel'] == 1) || (resBody.level > 1 && this.individualFilter['properties']['showTaskLevel'] == 2)) {
          if (this.individualFilter['properties']['exibitionType'] === 2) {
            this.$refs.kanban.editIntoList(resBody)
          } else {
            let task = this.items.find((value) => { return value.id === resBody.id }) || {}
            // Caso altera o cliente ou a equipe deve alterar para todas sub tarefas, pois clientes e equipes são o mesmo pra tarefa mae e pras filhas
            if ((resBody.client_id !== task.client_id) || (resBody.team_id !== task.team_id)) {
              this.recursiveAlter(task.all_subtasks, resBody)
            }
            Object.assign(task, JSON.parse(JSON.stringify(resBody || {})))
          }
        } else {
          topTask = this.items.find((value) => { return value.id === resBody.top_id })
          // nem sempre encontra o topTask no items. exemplo, no kanban não possui items e quando usa o finalizar mãe cai aqui
          if (topTask) {
            let sequence = this.changeOrderSequence(resBody.tree_task_sequence)
            this.editChildTask(resBody, sequence, topTask, topTask['id'])
          }
        }
      },
      close () {
        this.dialog = false
        this.editedItem = Object.assign(JSON.parse(JSON.stringify(this.defaultItem)), {})
        this.beforeEditedItem = Object.assign(JSON.parse(JSON.stringify(this.defaultItem)), {})
        this.loading = false
      },
      recursiveAlter (allSubtasks = [], task) {
        if (allSubtasks.length > 0) {
          allSubtasks.forEach((subtask) => {
            // Modifica o cliente e a equipe de todas as tarefas filhas quando a conexão ou a equipe da top for alterada
            subtask.client_id = task.client_id
            subtask.client = task.client
            subtask.team_id = task.team_id
            subtask.team = task.team
            if (subtask.all_subtasks.length > 0) {
              this.recursiveAlter(subtask.all_subtasks, task)
            }
          })
        }
      },
      editSubIdentifier (topTaskId, sequences) {
        this.$http.get(`api/get_sequence_expanded?task_id=${topTaskId}&sequenceExpanded=${sequences}`).then(res => {
          let topTask = this.items.find((value) => { return value.id === topTaskId })
          Object.assign(topTask, res.body)
        }, err => {
          console.log(err)
          this.$store.commit('snackbar/change_values', {
            text: `Ocorreu um erro ao alterar os ids!`,
            color: 'error',
            dialog: true
          })
        })
      },
      // editSubIdentifier (val, childs) {
      //   var sister = childs.find(sis => {
      //     return sis.id !== val.id && sis.identifier === val.identifier
      //   })
      //   if (!sister) {
      //     return true
      //   } else {
      //     sister.identifier++
      //     this.editSubIdentifier(sister, childs)
      //   }
      // },
      editChildTask (item, sequence = '', subTask = '', topTaskId = 0, i = 1) {
        if (item.id === subTask.id) {
          // caso o identifier seja diferente então deve editar a tarefa como um todo, para pegar a sequencia correta
          if (subTask['identifier'] != item['identifier']) {
            // busca os identifiers corretos da sequencia e edita eles
            this.editSubIdentifier(topTaskId, this.sequenceExpandedIds)
            // caso contrário edita apenas aquela tarefa
          } else {
            Object.assign(subTask, JSON.parse(JSON.stringify(item)))
          }
          return true
        } else {
          let sonItem = subTask.all_subtasks.find((val) => {
            return val.id === (sequence[i] ? sequence[i] : item.id)
          })
          if (sonItem) {
            i += 1
            this.editChildTask(item, sequence, sonItem, topTaskId, i)
          }
        }
      },
      clickMoreTask (index) {
        this.select = index * 25
        this.changePage(1, false)
      },
      updateSort (p) {
        this.$refs.filterTask.saveSpecificProps({sortBy: p['sortBy'], descending: p['descending']})
      },
      resizeCardTask (index) {
        // Pega o tamanho que tem que ser o card de tarefas considerando se esta aberto ou não a expansão das opções e se é de mobile ou naõ
        this.heightCardTask = (window.innerHeight || document.body.clientHeight) - ((this.$vuetify.breakpoint.smAndDown ? 50 : 0) + (this.individualFilter['properties']['exibitionType'] === 1 ? 300 : 200))
      },
      openDocumentPreviewList (taskId, tasktemplateId) {
        this.$refs.documentPreview.openDocumentPreviewList(taskId, tasktemplateId)
      }
    },
    destroyed () {
      this.$socket.emit('leaveRoom', {room: `tasks${this.$auth.user().id}`})
    },
    computed: {
      socketRoom: function () {
        return `${this.entity || ''}${this.$auth.user().id}`
      },
      headers: function () {
        return (this.individualFilter['properties']['showTaskLevel'] != 1) ? [
          {text: this.translate('table.' + this.entity + '.field.identifier'), value: 'identifier'},
          {text: this.translate('table.' + this.entity + '.field.id_text'), value: 'id_text'},
          {text: this.translate('table.' + this.entity + '.field.user_id'), value: 'user.id_text'},
          {text: this.translate('table.' + this.entity + '.field.client_id'), value: 'client.id_text'},
          {text: 'Previsão/Início', align: 'center', value: 'end'},
          {text: this.translate('table.' + this.entity + '.field.task_status_id'), value: 'status.id_text'},
          {text: this.checkPlanAccess('teams', 'active') ? this.translate('table.' + this.entity + '.field.team_id') : '', value: 'team.id_text'},
          {text: this.translate('table.' + this.entity + '.field.urgency'), value: 'urgency'},
          {text: this.translate('system.table.action'), value: 'action', sortable: false, align: 'center'}
        ] : [
          {text: this.translate('table.' + this.entity + '.field.all_subtasks'), value: 'all_subtasks', sortable: false},
          {text: this.translate('table.' + this.entity + '.field.identifier'), value: 'identifier'},
          {text: this.translate('table.' + this.entity + '.field.id_text'), value: 'id_text'},
          {text: this.translate('table.' + this.entity + '.field.user_id'), value: 'user.id_text'},
          {text: this.translate('table.' + this.entity + '.field.client_id'), value: 'client.id_text'},
          {text: 'Previsão/Início', align: 'center', value: 'end'},
          {text: this.translate('table.' + this.entity + '.field.task_status_id'), value: 'status.id_text'},
          {text: this.checkPlanAccess('teams', 'active') ? this.translate('table.' + this.entity + '.field.team_id') : '', value: 'team.id_text'},
          {text: this.translate('table.' + this.entity + '.field.urgency'), value: 'urgency'},
          {text: this.translate('system.table.action'), value: 'action', sortable: false, align: 'center'}
        ]
      }
    }
  }
</script>

<style scoped>
  .gif-loader {
    display: flex;
    width: 100%;
    min-height: 300px;
    align-items: center;
    justify-content: center
  }

  .consult-tasks {
    display: flex;
    align-content: start;
  }

  .empty-tasks {
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid #888;
    border-radius: 5px;
    padding: 10px;
    text-align: center;
  }

  .empty-tasks .empty-tasks-title{
    color: #555;
  }

  .empty-tasks .empty-tasks-image{
    width: 30%;
  }

  .empty-tasks .empty-tasks-image-mobile{
    width: 70%;
  }

  .empty-tasks .empty-tasks-body{
    color: #444;
  }

  tr td:last-child {
    min-width: 130px;
  }

  .fab-container {
    position: fixed;
    bottom: 16px;
    right: 16px;
    z-index: 4;
  }

  .badge {
    padding-right: 15px;
    padding-bottom: 10px;
  }

  .tab-buttons{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .v-datatable .v-table .theme--light {
    border-top: 3px solid rgba(0,0,0,0.12)!important;
    border-left: 3px solid rgba(0,0,0,0.12)!important;
    border-right: 3px solid rgba(0,0,0,0.12)!important;
    border-bottom: 3px solid rgba(0,0,0,0.12)!important;
  }
</style>


// WEBPACK FOOTER //
// src/components/Task.vue